import React from 'react';
import { FaUtensils, FaUmbrellaBeach, FaSeedling, FaBroom } from 'react-icons/fa';
import './AboutSection.css';

const services = [
  {
    icon: <FaUtensils />,
    title: 'Gıda Hizmetleri',
    description: 'Kafe ve Restoran İşletmeciliği',
    accent: '#D4A843',
    accentLight: 'rgba(212, 168, 67, 0.1)',
    accentHover: '#D4A843',
  },
  {
    icon: <FaUmbrellaBeach />,
    title: 'Turizm Hizmetleri',
    description: 'Turizm Geliştirme ve Yönetim İşletmeciliği',
    accent: '#5748B5',
    accentLight: 'rgba(87, 72, 181, 0.1)',
    accentHover: '#5748B5',
  },
  {
    icon: <FaSeedling />,
    title: 'Çiçekçilik Hizmetleri',
    description: 'Peyzaj ve Çiçekcilik Hizmetleri',
    accent: '#4A3BA8',
    accentLight: 'rgba(74, 59, 168, 0.1)',
    accentHover: '#4A3BA8',
  },
  {
    icon: <FaBroom />,
    title: 'Temizlik Hizmetleri',
    description: 'Temizlik ve Tedarik Yönetimi Hizmetleri',
    accent: '#2F2386',
    accentLight: 'rgba(47, 35, 134, 0.1)',
    accentHover: '#2F2386',
  },
];

const AboutSection = () => {

};

export default AboutSection;
